var Re = Object.defineProperty, ze = Object.defineProperties;
var We = Object.getOwnPropertyDescriptors;
var C = Object.getOwnPropertySymbols;
var ee = Object.prototype.hasOwnProperty, te = Object.prototype.propertyIsEnumerable;
var V = (o, n, r) => n in o ? Re(o, n, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[n] = r, ne = (o, n) => {
  for (var r in n || (n = {}))
    ee.call(n, r) && V(o, r, n[r]);
  if (C)
    for (var r of C(n))
      te.call(n, r) && V(o, r, n[r]);
  return o;
}, oe = (o, n) => ze(o, We(n));
var re = (o, n) => {
  var r = {};
  for (var l in o)
    ee.call(o, l) && n.indexOf(l) < 0 && (r[l] = o[l]);
  if (o != null && C)
    for (var l of C(o))
      n.indexOf(l) < 0 && te.call(o, l) && (r[l] = o[l]);
  return r;
};
import { jsxs as d, jsx as s } from "react/jsx-runtime";
import "react-datepicker/dist/react-datepicker.css";
import t from "dayjs";
import e from "../../../node_modules/prop-types/index.es.js";
import xe, { useState as c, useRef as je, useMemo as m, useEffect as ae } from "react";
import Ie from "react-datepicker";
import { renderElement as _e } from "../../../helpers/renderElement.es.js";
import { CustomSelect as ie } from "./CustomSelect.es.js";
import * as Fe from "./style.es.js";
import { DatePickerTooltip as $e, DatePicker as Le, DatePickerHeader as Xe, DatePickerHeaderSelects as qe, DatePickerInputContainer as Ke, DatePickerActionButtons as Ue, DatePickerActionButton as se, DatePickerTimeButton as k } from "./style.es.js";
import { range as Ze } from "../../../utils/validations.es.js";
import { Tooltip as Ge } from "../../DataDisplay/Tooltip/Tooltip.es.js";
import { Icon as g } from "../../DataDisplay/Icon/Icon.es.js";
import { Input as Je } from "../Input/Input.es.js";
import { IconButton as le } from "../Button/IconButton.es.js";
import { Helper as Qe } from "../../DataDisplay/Helper/Helper.es.js";
import { COMPONENT_SIZE as ue } from "../../../constants/sizes.es.js";
const Ve = Ie, et = t("1900-01-01").toDate(), tt = t().add(1, "year").toDate(), z = xe.forwardRef((rt, Me) => {
  var F = rt, {
    className: o,
    components: n = ot,
    defaultValue: r,
    disabled: l,
    error: v,
    excludeFuture: T = !1,
    excludePast: u = !1,
    formItem: p,
    helperText: pe,
    isActionButtonShown: de = !0,
    isYearPickerOptional: W = !1,
    maxDate: f,
    minDate: h,
    onBlur: x,
    onChange: D,
    placeholder: me,
    inputLabel: j,
    popperPlacement: fe = "left-start",
    showTimeSelect: y = !1,
    size: I = ue.md,
    success: _,
    value: O,
    dateFormat: he = "MMMM d",
    dateFormatWithTime: De = "MMMM d, yyyy h:mm aa",
    dateFormatWithYear: ye = "MMMM d, yyyy"
  } = F, be = re(F, [
    "className",
    "components",
    "defaultValue",
    "disabled",
    "error",
    "excludeFuture",
    "excludePast",
    "formItem",
    "helperText",
    "isActionButtonShown",
    "isYearPickerOptional",
    "maxDate",
    "minDate",
    "onBlur",
    "onChange",
    "placeholder",
    "inputLabel",
    "popperPlacement",
    "showTimeSelect",
    "size",
    "success",
    "value",
    "dateFormat",
    "dateFormatWithTime",
    "dateFormatWithYear"
  ]);
  var G;
  const [i, P] = c(r ? new Date(r) : null), [$, Ye] = c(null), [Ce, L] = c(!1), [ke, X] = c(!0), [S, q] = c(!1), [B, K] = c(!W), [w, ge] = c(Me), [ve, U] = c(!1), b = je(null), Te = /* @__PURE__ */ d($e, { children: [
    (G = n.timeCaption) == null ? void 0 : G.children,
    /* @__PURE__ */ s(Ge, { content: _e({
      content: n.timeCaption.tooltip.content,
      withBalancer: !0,
      style: {
        color: "var(--color-fg-inverse-default)"
      }
    }), children: /* @__PURE__ */ s(g, { name: "tooltip", size: "sm" }) })
  ] }), Oe = () => i ? t(i).format("YYYY-MM-DD") < t().format("YYYY-MM-DD") ? t(i).set("hour", 24).set("minute", 59).toDate() : t(i).format("YYYY-MM-DD") > t().format("YYYY-MM-DD") ? t().set("hour", 0).set("minute", 0).set("second", 0).toDate() : t().set("hour", t().toDate().getHours() + 1).set("minute", 0).toDate() : t().set("hour", 23).set("minute", 59).set("second", 59).toDate(), Pe = () => i ? t(i).format("YYYY-MM-DD") < t().format("YYYY-MM-DD") ? t(i).set("hour", 24).set("minute", 59).toDate() : t(i).format("YYYY-MM-DD") > t().format("YYYY-MM-DD") ? t().set("hour", 23).set("minute", 0).toDate() : t().set("hour", 23).set("minute", 0).toDate() : t().set("hour", 23).set("minute", 59).toDate(), Z = (a) => {
    t(a).isSame(t()) && t().isAfter(a, "hour") && u && (a == null || a.setHours(t().get("hour") + 1, 0, 0)), y && !S && (a == null || a.setHours(23, 59, 59)), X(!1), P(a);
  }, A = m(() => !f && u ? t().add(100, "year").toDate() : !f && (p == null ? void 0 : p.name) === "birthday" ? t().subtract(100, "year").toDate() : f || tt, [f]), H = m(() => !h && u ? /* @__PURE__ */ new Date() : !h && (p == null ? void 0 : p.name) === "birthday" ? t().subtract(100, "year").toDate() : h || et, [h]), E = m(() => ce(), [ce]), Se = m(() => E.map((a) => ({
    value: a,
    label: a
  })), [E]), Be = m(() => typeof v == "boolean" ? v : !!(u && i < /* @__PURE__ */ new Date() || T && i > /* @__PURE__ */ new Date()), [u, T, i]), we = m(() => {
    const a = t(H).get("year"), M = t(A).get("year");
    return Ze(a, M, 1).map((Y) => ({
      value: Y,
      label: Y
    })).sort(() => u ? 1 : -1);
  }, [H, A]);
  return ae(() => {
    O !== i && P(O);
  }, [O]), ae(() => {
    r && Z(new Date(r));
  }, []), /* @__PURE__ */ d(Le, { ref: ge, $showTimeSelect: S, $contentWidth: w == null ? void 0 : w.clientWidth, $isMenuOpen: ve, children: [
    /* @__PURE__ */ s(Ve, oe(ne({ ref: b, formatWeekDay: (a) => a.substr(0, 1), selected: i, onChange: Z, customInput: /* @__PURE__ */ s(Je, { variant: "outlined", inputProps: {
      readOnly: !0,
      placeholder: j || ""
    }, size: I, endIcon: /* @__PURE__ */ s(g, { name: "calendar", onClick: () => b.current.setOpen(!0) }), label: !j && me, className: o, error: !l && Be, success: _, helperProps: {
      counter: void 0
    } }), disabledKeyboardNavigation: !0, popperPlacement: fe, showPopperArrow: !1, minDate: H, maxDate: A, minTime: Oe(), maxTime: Pe(), filterDate: T ? (a) => t().toDate() > a : !1, showTimeSelect: y, timeFormat: "hh:mm a", timeIntervals: 60, popperProps: {
      strategy: "fixed"
    }, timeCaption: Te, dateFormat: y ? De : B ? ye : he, showMonthDropdown: !0, shouldCloseOnSelect: !1, popperClassName: "date-picker-popper", onCalendarOpen: () => {
      U(!0), Ye(i), L(!1);
    }, onCalendarClose: () => {
      U(!1), $ !== i && !Ce && D && D(i), x && x(i);
    }, showYearDropdown: !0, renderCustomHeader: ({
      changeYear: a,
      changeMonth: M,
      decreaseMonth: J,
      increaseMonth: Y,
      prevMonthButtonDisabled: Ae,
      nextMonthButtonDisabled: He,
      monthDate: N
    }) => {
      const Q = N.toLocaleString("en-US", {
        month: "long"
      }), Ee = {
        value: Q,
        label: Q
      }, Ne = {
        value: N.getFullYear(),
        label: N.getFullYear()
      };
      return /* @__PURE__ */ d(Xe, { children: [
        /* @__PURE__ */ s(le, { size: "sm", onClick: () => J(), disabled: Ae, variant: "link", color: "secondary", type: "button", children: /* @__PURE__ */ s(g, { name: "left-chevron" }) }),
        /* @__PURE__ */ d(qe, { children: [
          /* @__PURE__ */ s(ie, { options: Se, onChange: (R) => M(E.indexOf(R.value)), defaultOption: Ee, styles: {
            valueContainer: () => ({
              minWidth: 80
            }),
            control: () => ({
              border: "none",
              background: "transparent"
            })
          } }),
          B && /* @__PURE__ */ s(ie, { options: we, onChange: (R) => a(R.value), defaultOption: Ne, styles: {
            control: () => ({
              border: "none",
              background: "transparent"
            })
          } })
        ] }),
        /* @__PURE__ */ s(le, { size: "sm", onClick: Y, disabled: He, variant: "link", color: "secondary", type: "button", children: /* @__PURE__ */ s(g, { name: "right-chevron" }) })
      ] });
    } }, be), { children: /* @__PURE__ */ d(Ke, { children: [
      de && /* @__PURE__ */ d(Ue, { children: [
        /* @__PURE__ */ s(se, { type: "button", variant: "text", color: "secondary", onClick: () => {
          P($), L(!0), b.current.setOpen(!1);
        }, size: "sm", children: "Cancel" }),
        /* @__PURE__ */ s(se, { type: "button", onClick: () => {
          D && D(i), X(!0), b.current.setOpen(!1);
        }, size: "sm", disabled: ke, children: "Set date" })
      ] }),
      W && (B ? /* @__PURE__ */ s(k, { type: "button", variant: "link", onClick: () => K(!1), children: "Hide year picker" }) : /* @__PURE__ */ s(k, { type: "button", variant: "link", onClick: () => K(!0), children: "Show year picker" })),
      y && (S ? /* @__PURE__ */ s(k, { type: "button", variant: "link", color: "secondary", onClick: () => q(!1), children: n.openTimeButton.childrenClose }) : /* @__PURE__ */ s(k, { type: "button", variant: "link", color: "secondary", onClick: () => q(!0), children: n.openTimeButton.children }))
    ] }) })),
    /* @__PURE__ */ s(Qe, { text: pe, error: v, size: I, success: _ })
  ] });
}), nt = {
  className: e.string,
  components: e.shape({
    submitButton: e.shape({
      children: e.node
    }),
    cancelButton: e.shape({
      children: e.node
    }),
    openTimeButton: e.shape({
      children: e.node,
      childrenClose: e.node
    }),
    timeCaption: e.shape({
      children: e.node,
      tooltip: e.shape({
        content: e.node
      })
    })
  }),
  defaultValue: e.instanceOf(Date),
  error: e.bool,
  excludeFuture: e.bool,
  excludePast: e.bool,
  formItem: e.any,
  helperText: e.string,
  isActionButtonShown: e.bool,
  isYearPickerOptional: e.bool,
  maxDate: e.instanceOf(Date),
  minDate: e.instanceOf(Date),
  onBlur: e.func,
  onChange: e.func.isRequired,
  placeholder: e.string,
  inputLabel: e.string,
  popperPlacement: e.string,
  showTimeSelect: e.bool,
  disabled: e.bool,
  size: e.oneOf(Object.values(ue)),
  success: e.bool,
  value: e.instanceOf(Date)
};
z.displayName = "DateTimePicker";
z.S = Fe;
z.propTypes = nt;
const ot = {
  submitButton: {
    children: "Set Date"
  },
  cancelButton: {
    children: "Cancel"
  },
  openTimeButton: {
    children: "Want to set a specific end time?",
    childrenClose: "Do not set a specific end time"
  },
  timeCaption: {
    children: "Time",
    tooltip: {
      content: "Selected time is based on your time zone"
    }
  }
}, ce = (o = "en", n = {
  month: "long"
}) => Array.from({
  length: 12
}, (r, l) => new Date(null, l + 1, null).toLocaleDateString(o, n));
export {
  z as DateTimePicker,
  nt as datePickerPropTypes
};
//# sourceMappingURL=DateTimePicker.es.js.map
